/**
 * Auth headers for the Learning-Lifecycle (v3/admin) API family — id token,
 * access token, and the Auth0 org id read from the access token claims.
 * Mirrors useAdminLearningLifecycle's local getAuthHeaders so surfaces outside
 * that hook (wizard Invite & Finish, Members-page audience preview) can call
 * the same endpoints.
 */
export const getLLAuthHeaders = (): { idtoken: string; authorization: string; orgid: string } => {
  try {
    const raw = localStorage.getItem('tokens');
    const tokens = raw ? JSON.parse(raw) : {};
    const accessRaw = tokens.access_token || '';
    let orgid = '';
    try {
      const payload = JSON.parse(atob(accessRaw.split('.')[1] || ''));
      orgid = payload?.['https://dosen.io/organization']?.id || '';
    } catch {
      // malformed token — orgid stays empty, BE falls back to other signals
    }
    return { idtoken: tokens.id_token || '', authorization: accessRaw, orgid };
  } catch {
    return { idtoken: '', authorization: '', orgid: '' };
  }
};
